import React, { Component } from 'react'
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap'
import _ from 'lodash'
import ReactTable from 'react-table'

import PageTitle from 'components/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import Lang from 'Lang/General'
import FaqCategoriesHOC from './actions'
import FaqCategoryForm from './components/faqCategoryForm'
import DeleteConfirmationDialog from 'components/Modal/delete'

class FaqCategories extends Component {
  componentDidMount = () => {
    this.props.getFaqCategories()
  }

  componentDidUpdate = pp => {
    if( pp.showCreateFaqCategory && !this.props.showCreateFaqCategory ){
      let tmp = {
        name: {
          en: '',
          de: '',
          nl: '',
          it: '',
          fr: ''
        },
        description: {
          en: '',
          de: '',
          nl: '',
          it: '',
          fr: ''
        }
      }
      this.props.onChangeFaqCategoriesHOC( 'newFaqCategory', tmp )
    }

    if( pp.showUpdateFaqCategory && !this.props.showUpdateFaqCategory ){
      this.props.onChangeFaqCategoriesHOC( 'selectedFaqCategory', {
        name: {
          en: '',
          de: '',
          nl: '',
          it: '',
          fr: ''
        },
        description: {
          en: '',
          de: '',
          nl: '',
          it: '',
          fr: ''
        }} )
    }
  }

  handleSecurityModulesCreate = () => {
    let tmp = _.find( this.props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Online Shop' })
      return tmpModules.is_create
    }
  }

  handleSecurityModulesUpdate = () => {
    let tmp = _.find( this.props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Online Shop' })
      return tmpModules.is_update
    }
  }

  handleSecurityModulesDelete = () => {
    let tmp = _.find( this.props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Online Shop' })
      return tmpModules.is_delete
    }
  }

  renderCreateForm = () => (
    <Modal isOpen={ this.props.showCreateFaqCategory } size='xl' >
      <ModalHeader toggle={ () => this.props.onChangeFaqCategoriesHOC( 'showCreateFaqCategory', false ) }>
        { Lang[ 'CREATE_FAQ_CATEGORY' ][ this.props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <FaqCategoryForm
          faqCategoryType='newFaqCategory'
          currentFaqCategory={ this.props.newFaqCategory }
          selectedLanguageShortname={ this.props.data.languageReducer.lang }
          onChangeFaqCategoriesHOC={ this.props.onChangeFaqCategoriesHOC } />
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => this.props.createFaqCategory( this.props.newFaqCategory ) }>
          { Lang[ 'SUBMIT' ][ this.props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
      { this.props.onLoadFaqCategories && <LoadingOverlay/> }
    </Modal>
  )

  renderUpdateForm = () => (
    <Modal isOpen={ this.props.showUpdateFaqCategory } size='xl' >
      <ModalHeader toggle={ () => this.props.onChangeFaqCategoriesHOC( 'showUpdateFaqCategory', false ) }>
        { Lang[ 'UPDATE_FAQ_CATEGORY' ][ this.props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <FaqCategoryForm
          faqCategoryType='selectedFaqCategory'
          currentFaqCategory={ this.props.selectedFaqCategory }
          selectedLanguageShortname={ this.props.data.languageReducer.lang }
          onChangeFaqCategoriesHOC={ this.props.onChangeFaqCategoriesHOC } />
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => this.props.updateFaqCategory( this.props.selectedFaqCategory.id, this.props.selectedFaqCategory ) }>
          { Lang[ 'SUBMIT' ][ this.props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
      { this.props.onLoadFaqCategories && <LoadingOverlay/> }
    </Modal>
  )

  render = () => {
    return(
      <>
        <PageTitle
          heading={ Lang[ 'FAQ_CATEGORIES' ][ this.props.data.languageReducer.lang ] }
          icon="pe-7s-network icon-gradient bg-happy-fisher"
          buttons={[
            {
              buttonText: Lang[ 'CREATE' ][ this.props.data.languageReducer.lang ],
              onClick: () => this.props.onChangeFaqCategoriesHOC( 'showCreateFaqCategory', true ),
              display: this.handleSecurityModulesCreate()
            }
        ]}/>
        <Card>
          <CardBody>
            <ReactTable
              pageSize={ 20 }
              NoDataComponent={ () => <span></span> }
              showPagination={ true }
              data={ this.props.faqCategories.data }
              columns={[
                {
                  Header: Lang[ 'TITLE' ][ this.props.data.languageReducer.lang ],
                  accessor: 'name',
                  Cell: ( row ) => row.original.name[ this.props.data.languageReducer.lang ]
                },
                {
                  Header: Lang[ 'ACTION' ][ this.props.data.languageReducer.lang ],
                  accessor: 'id',
                  Cell: ( row ) => (
                    <div className="d-flex flex-row align-items-center justify-content-center w-100">
                      {
                        this.handleSecurityModulesUpdate() && (
                          <>
                            <Button
                              id={ `Faq-categories-${ row.original.id }-update-faq-category` }
                              className="mb-2 mr-2 btn-icon btn-icon-only"
                              color='primary'
                              onClick={ () => {
                                this.props.onChangeFaqCategoriesHOC( 'showUpdateFaqCategory', true )
                                this.props.getSelectedFaqCategory( row.original.id )} } >
                              <i className="pe-7s-pen btn-icon-wrapper" />
                            </Button>
                            <UncontrolledTooltip
                              target={ `Faq-categories-${ row.original.id }-update-faq-category` }
                              placement="top">{ Lang[ 'UPDATE_FAQ_CATEGORY_SEN_CASE' ][ this.props.data.languageReducer.lang ] }</UncontrolledTooltip>
                          </>
                        )
                      }
                      {
                        this.handleSecurityModulesDelete() && (
                          <>
                            <Button
                              id={ `Faq-categories-${ row.original.id }-remove-faq-category` }
                              className="mb-2 mr-2 btn-icon btn-icon-only"
                              color='danger'
                              onClick={ () => this.props.onChangeFaqCategoriesHOC( 'showDeleteFaqCategoryId', row.original.id )}
                             >
                              <i className="pe-7s-trash btn-icon-wrapper" />
                            </Button>
                            <UncontrolledTooltip
                              target={ `Faq-categories-${ row.original.id }-remove-faq-category` }
                              placement="top">{ Lang[ 'REMOVE_FAQ_CATEGORY' ][ this.props.data.languageReducer.lang ] }</UncontrolledTooltip>
                          </>
                        )
                      }
                    </div>
                  )
                }
              ]}/>
          </CardBody>
          {
            this.props.showDeleteFaqCategoryId && (
              <DeleteConfirmationDialog
                deleteOpen={ this.props.showDeleteFaqCategoryId ? true : false }
                handleModalClose={ () => this.props.onChangeFaqCategoriesHOC( 'showDeleteFaqCategoryId', null )}
                confirmAction={ () => this.props.removeFaqCategory( this.props.showDeleteFaqCategoryId )}
                content={ Lang[ 'DELETE_CONFIRMATION_FAQ_CATEGORY' ][ this.props.data.languageReducer.lang ] }
                lang={ this.props.data.languageReducer.lang }/>
            )
          }
        </Card>
        { this.renderCreateForm() }
        { this.renderUpdateForm() }
        { this.props.onLoadFaqCategories && <LoadingOverlay/> }
      </>
    )
  }
}

export default FaqCategoriesHOC( FaqCategories )
